import { Component, AfterViewInit, OnInit, Input } from '@angular/core';
import { AuthService } from '../services/auth.service';
declare var $: any;
@Component({
    selector: 'vnpt-menu',
    styles: [`
      .open > vnpt-menu > .dropdown-menu {
          display: block !important;
      }
    `],
    template: `
<ul [ngClass]="{'nav': !subMenu, 'navbar-nav': !subMenu, 'dropdown-menu': subMenu}">
    <template ngFor let-item [ngForOf]="listItems">
        <li *ngIf="!item.HaveChild">
            <a *ngIf="item.IsRoot" routerLink="{{item.RouterPath}}">
                <span>{{item.Ten}}</span>
            </a>
            <a *ngIf="!item.IsRoot" routerLink="{{item.RouterPath}}">
                {{item.Ten}}
            </a>
        </li>
        <li [ngClass]="{'dropdown':item.IsRoot, 'dropdown-submenu':!item.IsRoot}" *ngIf="item.HaveChild">
            <a class="dropdown-toggle" data-toggle="dropdown" href="#" *ngIf="item.IsRoot">
                {{item.Ten}} <span class="fa fa-angle-down"></span>
            </a>
            <a tabindex="-1" *ngIf="!item.IsRoot" style="display: flex;justify-content: space-between;align-items: center;">
                {{item.Ten}} <span class="fa fa-angle-right" style="transform: scale(1.5);"></span>
            </a>
            
            <vnpt-menu [listItems]="item.ChildList" [subMenu]="true" [display_chat]="false"></vnpt-menu>
        </li>
    </template>
    <li *ngIf="display_chat && show_chat">
        <a routerLink="chat/messenger">
            <span>{{auth.systemConfig?.chat?.name}}</span>
        </a>
    </li>
<ul>
`,
})
export class VnptMenuComponent implements OnInit {
    @Input("listItems") listItems;
    @Input("subMenu") subMenu;

    @Input("display_chat") display_chat = true;

    get show_chat(): boolean {
        if (this.auth.systemConfig && this.auth.systemConfig.chat) {
            return !!this.auth.systemConfig.chat.show_chat;
        }
        return false;
    }
    constructor(public auth: AuthService) { }
    ngOnInit() {
    }
    ngAfterViewInit() {
        $('.scrollWrap').mCustomScrollbar({
            theme: 'dark-3'
        });
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/directives/vnpt-menu.component.ts